import { CurrentSectionSpiIt } from '@ingenico/react-section-utils';
import { deviceManagementContainer } from '../container.const';
import type { DeviceManagementSpiPort, GoogleMapConfig } from '../domain/hexa/ports/spi.model';

export function useGoogleMapConfig(): GoogleMapConfig | undefined {
  if (!deviceManagementContainer.isBound(CurrentSectionSpiIt)) {
    return undefined;
  }

  return deviceManagementContainer.get<DeviceManagementSpiPort>(CurrentSectionSpiIt).getGoogleMapConfig?.();
}
